import { UserApi } from "@/api";
import router from "@/router";
import { showSuccessSnackbar } from "@/utilities/snackbar";
import i18n from "@/i18n";

export async function getAllFromFirm(firmId = undefined) {
  const { data } = await UserApi.getAllFromFirm(firmId);
  return data;
}

export async function getByEnterpriseId(enterpriseId) {
  let data;
  try {
    ({ data: data } = await UserApi.getByEnterpriseId(enterpriseId));
  } catch (ex) {
    // TODO: Backend never returns 404, if it does, we shouldn't redirect to dashboard
    if (ex.response.status === 404) {
      router.push({ name: "dashboard" });
    }
  }
  return data;
}

export async function toggle(userId) {
  const { data: response } = await UserApi.toggle(userId);
  return response;
}

export async function changePassword(data) {
  const { data: response } = await UserApi.changePassword(data);
  showSuccessSnackbar(200, i18n.t("password-change-success"));
  return response;
}

export async function sendValidationEmail(userId) {
  const { data: response } = await UserApi.sendValidationEmail(userId);
  showSuccessSnackbar(200, i18n.t("validation-email-sent"));
  return response;
}

export async function getUserEnterprises(userId) {
  const { data } = await UserApi.getUserEnterprises(userId);
  return data;
}

export async function updateUserEnterprises(userId, enterpriseIds) {
  await UserApi.updateUserEnterprises(userId, enterpriseIds);
  showSuccessSnackbar(200, i18n.t("save-enterprise-access-success"));
}
